<!--<h4>Calendar</h4>-->
<p>
    The Canvas Assignments widget pulls information in real-time from our Canvas Learning Management System.
</p>
